import script from "./customer-service.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-service.vue?vue&type=script&setup=true&lang=js"

import "./customer-service.vue?vue&type=style&index=0&id=75a95e21&lang=scss&scoped=true"

import exportComponent from "/mnt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a95e21"]])

export default __exports__